export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "defaultOptionText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-- 선택해주세요 --"])}
    }
  })
}
